import { PAGE_SIZE } from './constant';
/**
 * @description: 注册事件
 * @param {type}
 * @return:
 */

export var registerEvent = function registerEvent(obj, sType, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(sType, fn, false);
  } else {
    obj.attachEvent("on".concat(sType), fn);
  }
};
/**
 * @description: 卸载事件
 * @param {type}
 * @return:
 */

export var unmountEvent = function unmountEvent(obj, sType, fn) {
  if (obj.removeEventListener) {
    obj.removeEventListener(sType, fn, false);
  } else {
    obj.detachEvent("on".concat(sType), fn);
  }
};
/**
 * @description: 取消默认事件
 * @param {type}
 * @return:
 */

export var preventDefaultEvent = function preventDefaultEvent(ev) {
  var zoEvent = ev || window.event;

  if (zoEvent.preventDefault) {
    zoEvent.preventDefault();
  }

  return zoEvent;
};
/**
 * @description: 获取鼠标移动后图片偏移量
 * @param {type} background 图片父div ref，图片ref，鼠标 move event
 * @from : https://github.com/Caldis/react-zmage
 * @return: left, top
 */

export var getTranslate = function getTranslate(bg, img, e) {
  var mouseX = e.clientX,
      mouseY = e.clientY;

  var _bg$getBoundingClient = bg.getBoundingClientRect(),
      bgLeft = _bg$getBoundingClient.left,
      bgTOP = _bg$getBoundingClient.top;

  var _img$getBoundingClien = img.getBoundingClientRect(),
      naturalWidth = _img$getBoundingClien.width,
      naturalHeight = _img$getBoundingClien.height; // 随鼠标位移偏移量


  var saveEdge = 170;
  var viewWidth = bg.offsetWidth;
  var viewHeight = bg.offsetHeight;
  var rangeX = naturalWidth - viewWidth + 2 * saveEdge;
  var rangeY = naturalHeight - viewHeight + 2 * saveEdge;
  var imgPosX = naturalWidth > viewWidth ? (naturalWidth - viewWidth) / 2 + saveEdge - rangeX * ((mouseX - bgLeft) / viewWidth) : 0;
  var imgPosY = naturalHeight > viewHeight - 132 ? (naturalHeight - viewHeight) / 2 + saveEdge - rangeY * ((mouseY - bgTOP) / viewHeight) : 0;
  return {
    imgPosX: imgPosX,
    imgPosY: imgPosY
  };
};
/**
 * @description: 获取导航图片
 * @param: 原图片集、导航图片集起始index
 * @return: 导航图片集
 */

export var getNavImgs = function getNavImgs(imgs, startIndex) {
  return imgs.slice(startIndex, startIndex + PAGE_SIZE);
};
export var getValidateStatis = function getValidateStatis(data) {
  return data && data.validateStatus === 'VALIDATED';
};
export var isEqual = function isEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  if (JSON.stringify(arr1) === JSON.stringify(arr2)) {
    return true;
  }

  return false;
};
export var isBelong = function isBelong(fatherArray, childArray) {
  return fatherArray.includes(childArray);
};
export var downloadFromLink = function downloadFromLink(href, name) {
  var downloadLink = document.createElement('a');
  downloadLink.href = href;
  downloadLink.download = name || href.split('/')[href.split('/').length - 1];
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

function getBrowser() {
  var explorer = window.navigator.userAgent; // 判断是否为IE浏览器

  if (explorer.indexOf('MSIE') >= 0 || explorer.indexOf('Trident') > -1 && explorer.indexOf('rv:11.0') > -1) {
    return 'IE';
  } // 判断是否为Firefox浏览器


  if (explorer.indexOf('Firefox') >= 0) {
    return 'FF';
  } // 判断是否为Chrome浏览器


  if (explorer.indexOf('Chrome') >= 0) {
    return 'CH';
  } // 判断是否为Opera浏览器


  if (explorer.indexOf('Opera') >= 0) {
    return 'OP';
  } // 判断是否为Safari浏览器


  if (explorer.indexOf('Safari') >= 0) {
    return 'SA';
  }

  return false;
} // 使用pdf插件打开pdf


export var openPdf = function openPdf(resourceUrl, isOpenDirectory, isPreviewOnly) {
  var indexPage = ['IE'];

  if (indexPage.indexOf(getBrowser()) !== -1 && !isPreviewOnly) {
    // IE各种坑
    window.location.href = resourceUrl;
    return;
  }

  if (isOpenDirectory) {
    window.open(resourceUrl);
  } else {
    var page = 'browser';

    if (getBrowser() === 'SA') {
      page = 'index';
    }

    window.open("/web/pdf-viewer/".concat(page, ".html?file=").concat(encodeURIComponent(resourceUrl)));
  }
};
//# sourceMappingURL=utils.js.map
